/**
 * 字段生成规则
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 字段生成规则
 */
export class GSPColumnGenerate {

    /**
     * 元素ID，此属性应该是ElementID，而不是ColumnID
     */
    public ElementID: string;

    /**
     * 生成类型
     */
    public GernerateType: string;
}
